import { render, staticRenderFns } from "./UsersTable.vue?vue&type=template&id=65850c75&scoped=true"
import script from "./UsersTable.ts?vue&type=script&lang=ts&external"
export * from "./UsersTable.ts?vue&type=script&lang=ts&external"
import style0 from "./UsersTable.vue?vue&type=style&index=0&id=65850c75&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65850c75",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65850c75')) {
      api.createRecord('65850c75', component.options)
    } else {
      api.reload('65850c75', component.options)
    }
    module.hot.accept("./UsersTable.vue?vue&type=template&id=65850c75&scoped=true", function () {
      api.rerender('65850c75', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/UsersManager/components/tables/UsersTable/UsersTable.vue"
export default component.exports